export default __webpack_public_path__ + "static/media/103t.81538926.jpg";